import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faFilter,
  faCalendarAlt,
  faFileExcel,
  faTimes,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { DateRangePicker } from "react-date-range";

const EnhancedSearchAndFilterBar = ({
  searchTerm,
  setSearchTerm,
  setShowFilters,
  showFilters,
  setShowDatePicker,
  showDatePicker,
  dateRange,
  setDateRange,
  clearFilterType,
  transformDataForCSV,
  filteredData,
  ExportCSVButton,
}) => {
  return (
    <div className="mb-6">
      {/* Main search and filter bar */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
        <div className="p-4">
          <div className="flex flex-col md:flex-row gap-3">
            {/* Search input */}
            <div className="w-full md:w-1/2 lg:w-2/5">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Search shipments, customers, references..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                />
                {searchTerm && (
                  <button
                    onClick={() => setSearchTerm("")}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                )}
              </div>
            </div>

            {/* Buttons group */}
            <div className="flex flex-wrap gap-2 justify-end ml-auto">
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                  showFilters
                    ? "bg-blue-100 text-blue-700 border border-blue-200"
                    : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
                }`}
              >
                <FontAwesomeIcon icon={faFilter} />
                <span>Filters</span>
                <FontAwesomeIcon
                  icon={showFilters ? faChevronUp : faChevronDown}
                  className="text-xs"
                />
              </button>

              <button
                onClick={() => setShowDatePicker(!showDatePicker)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                  showDatePicker ||
                  (dateRange[0].startDate && dateRange[0].endDate)
                    ? "bg-blue-100 text-blue-700 border border-blue-200"
                    : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
                }`}
              >
                <FontAwesomeIcon icon={faCalendarAlt} />
                <span>Date Range</span>
                {showDatePicker ? (
                  <FontAwesomeIcon icon={faChevronUp} className="text-xs" />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
                )}
              </button>

              <ExportCSVButton
                data={transformDataForCSV(filteredData)}
                filename="traffics.csv"
                className="flex items-center gap-2 px-4 py-2.5 bg-green-50 text-green-700 border border-green-200 rounded-lg text-sm font-medium hover:bg-green-100 transition-colors"
              >
                <FontAwesomeIcon icon={faFileExcel} />
                <span>Export Data</span>
              </ExportCSVButton>
            </div>
          </div>
        </div>

        {/* Date picker dropdown */}
        {showDatePicker && (
          <div className="border-t border-gray-200 bg-gray-50 p-4">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-medium text-gray-700">Select Date Range</h3>
              <div className="flex gap-2">
                <button
                  onClick={() => clearFilterType("dateRange")}
                  className="text-sm text-gray-500 hover:text-red-600 transition-colors"
                >
                  Clear Range
                </button>
                <button
                  onClick={() => setShowDatePicker(false)}
                  className="text-sm text-gray-500 hover:text-gray-800 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="border border-gray-300 rounded-lg shadow-md bg-white">
                <DateRangePicker
                  ranges={dateRange}
                  onChange={(ranges) => setDateRange([ranges.selection])}
                  months={2}
                  direction="horizontal"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Date Range Filter Display */}
      {dateRange[0].startDate && dateRange[0].endDate && !showDatePicker && (
        <div className="mt-3 flex">
          <span className="bg-blue-50 text-blue-700 px-3 py-1.5 rounded-lg flex items-center text-sm border border-blue-100">
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
            <span className="font-medium mr-1">Date Range:</span>
            {new Date(dateRange[0].startDate).toLocaleDateString()} -{" "}
            {new Date(dateRange[0].endDate).toLocaleDateString()}
            <button
              onClick={() => clearFilterType("dateRange")}
              className="ml-2 text-blue-500 hover:text-blue-700 transition-colors"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

export default EnhancedSearchAndFilterBar;
